import { createInvitesColumnDefinitions } from "../InvitesTableColumns";

const invitesColumnDefinitions = createInvitesColumnDefinitions();

export const INVITES_FIXED_COLUMNS = Object.keys(
  invitesColumnDefinitions
).slice(0, 2);

export const DEFAULT_INVITES_VISIBLE_COLUMNS = Object.keys(
  invitesColumnDefinitions
).filter((key) => !INVITES_FIXED_COLUMNS.includes(key));

export const invitesColumnOptions = Object.values(invitesColumnDefinitions)
  .filter(({ key }) => !INVITES_FIXED_COLUMNS.includes(key))
  .map(({ key, label }) => ({ text: label, value: key }));
